import questionService from "../../services/questionService/service";
import QuestionModel from "../../models/questionModel/model";
export default {
    async getQuestion(search, page, limit, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
            const { data, headers } = await questionService.getQuestion(sanitizedSearch, page, limit, company);
            return {
                data: data.map(question => new QuestionModel(question)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error(error);
        }
    },
    async totalAllQuestion(query, company) {
        try {
            return await questionService.totalAllQuestion(query, company);
        } catch (error) {
            console.error('Error fetching questions:', error);
            throw error;
        }
    },
    async addQuestion(question) {
        try {
            return await questionService.addQuestion(question);
        } catch (error) {
            console.error('Error adding question:', error);
            throw error;
        }
    },
    async updateQuestion(question) {
        try {
            return await questionService.updateQuestion(question);
        } catch (error) {
            console.error('Error updating question:', error);
            throw error;
        }
    },
    async deleteQuestion(id) {
        try {
            return await questionService.deleteQuestion(id);
        } catch (error) {
            console.error('Error deleting question:', error);
            throw error;
        }
    },
    async getAnswer(id){
        try {
            return await questionService.getAnswer(id);
        } catch (error) {
            console.error('Error fetching answers:', error);
            throw error;
        }
    },
    async getQuestionDetail(id){
        try {
            return await questionService.getQuestionDetail(id);
        } catch (error){
            console.error('Error fetching question detail:', error);
            throw error;
        }
    },
    async addAnswer(id) {
        try {
            return await questionService.addAnswer(id);
        } catch (error) {
            console.error('Error adding answer:', error);
            throw error;
        }
    },
    async getAnswerDetail(id){
        try {
            return await questionService.getAnswerDetail(id);
        } catch (error) {
            console.error('Error fetching question detail:', error);
            throw error;
        }
    },
    async deleteAnswerbyQuestion(id){
        try {
            return await questionService.deleteAnswerbyQuestion(id);
        } catch (error) {
            console.error('Error deleting answer:', error);
            throw error;
        }
    },
    async deleteDetail(id){
        try {
            return await questionService.deleteDetail(id);
        } catch (error) {
            console.error('Error deleting answer:', error);
            throw error;
        }
    }
}